import React from 'react'
import { Box, Title, Text } from '@mantine/core'

const HomePage = ({ orgSlug }) => {
	return (
		<Box px='md' py='md'>
			<Title order={2}>No Experience Assigned</Title>
			<Text mt='sm'>
				You are currently a member this organization, but you don't have an
				active experience assignment. Please contact your administrator.
			</Text>
		</Box>
	)
}

export default HomePage
